import React from "react";

const SixBoxSkeleton = () => {
  return (
    <div className="flex gap-1">
      <div className="h-11 w-11 rounded-md bg-gray-300"></div>
      <div className="h-11 w-11 rounded-md bg-gray-300"></div>
      <div className="h-11 w-11 rounded-md bg-gray-300"></div>
      <div className="h-11 w-11 rounded-md bg-gray-300"></div>
      <div className="h-11 w-11 rounded-md bg-gray-300"></div>
      <div className="h-11 w-11 rounded-md bg-gray-300"></div>
    </div>
  );
};

export default SixBoxSkeleton;
